(() => {
  'use strict';
  function initProduct(root) {
    if (root.dataset.bound) return; root.dataset.bound = 'true';
    const select = root.querySelector('[data-variant-select]');
    const variants = JSON.parse(root.querySelector('[data-variants]').textContent);
    const options = root.querySelector('[data-option-buttons]');
    const track = root.querySelector('[data-gallery-track]');
    let galleryTarget = null;
    let galleryCurrent = null;
    let galleryTimer;
    const galleryQueue = [];
    const gallerySlides = () => [...track.children].filter(slide => !slide.hidden && !slide.hasAttribute('data-gallery-clone'));
    const galleryPages = () => [...track.children].filter(slide => !slide.hidden);
    const galleryLeft = slide => slide.offsetLeft - track.offsetLeft;
    const nearestGalleryPage = () => galleryPages().reduce((nearest, slide) =>
      !nearest || Math.abs(galleryLeft(slide) - track.scrollLeft) < Math.abs(galleryLeft(nearest) - track.scrollLeft) ? slide : nearest, null);
    function realGallerySlide(slide) {
      const slides = gallerySlides();
      return slide?.dataset.galleryClone === 'before' ? slides.at(-1) : slide?.dataset.galleryClone === 'after' ? slides[0] : slide;
    }
    function resetGalleryTarget() {
      clearTimeout(galleryTimer);
      galleryTarget = null;
      galleryQueue.length = 0;
    }
    function finishGalleryMove() {
      clearTimeout(galleryTimer);
      const page = galleryTarget || nearestGalleryPage();
      // Ignore stale scrollend events when a new move has already started.
      if (!page || Math.abs(track.scrollLeft - galleryLeft(page)) > 1) return;
      galleryTarget = null;
      galleryCurrent = realGallerySlide(page);
      // The boundary copy and the original look identical, so this reset is invisible.
      if (page !== galleryCurrent) track.scrollTo({ left: galleryLeft(galleryCurrent), behavior: 'instant' });
      advanceGallery();
    }
    function settleGallery() {
      clearTimeout(galleryTimer);
      galleryTimer = setTimeout(finishGalleryMove, 180);
    }
    function advanceGallery() {
      if (galleryTarget || !galleryQueue.length) return;
      let current = nearestGalleryPage();
      const real = realGallerySlide(current);
      if (real !== current) {
        track.scrollTo({ left: galleryLeft(real), behavior: 'instant' });
        current = real;
      }
      const pages = galleryPages();
      galleryTarget = pages[pages.indexOf(current) + galleryQueue.shift()];
      if (!galleryTarget) return;
      track.scrollTo({ left: galleryLeft(galleryTarget), behavior: 'smooth' });
      settleGallery();
    }
    function moveGallery(direction) {
      if (gallerySlides().length < 2) return;
      // Finish each adjacent move before handling another click, including at the seam.
      galleryQueue.push(direction);
      advanceGallery();
    }
    function rebuildGallery(media) {
      resetGalleryTarget();
      track.querySelectorAll('[data-gallery-clone]').forEach(slide => slide.remove());
      const slides = gallerySlides();
      function copySlide(slide, position) {
        const copy = slide.cloneNode(true);
        copy.dataset.galleryClone = position;
        copy.removeAttribute('data-media-id');
        copy.removeAttribute('data-frame');
        copy.setAttribute('aria-hidden', 'true');
        copy.setAttribute('inert', '');
        [copy, ...copy.querySelectorAll('[id]')].forEach(node => node.removeAttribute('id'));
        copy.querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
        return copy;
      }
      if (slides.length > 1) {
        track.prepend(copySlide(slides.at(-1), 'before'));
        track.append(copySlide(slides[0], 'after'));
      }
      galleryCurrent = media || slides[0];
      root.querySelector('[data-gallery-prev]').disabled = slides.length < 2;
      root.querySelector('[data-gallery-next]').disabled = slides.length < 2;
      track.scrollTo({ left: galleryCurrent ? galleryLeft(galleryCurrent) : 0, behavior: 'instant' });
    }
    function interruptGallery() {
      resetGalleryTarget();
      track.scrollTo({ left: track.scrollLeft, behavior: 'instant' });
    }
    track.addEventListener('scroll', settleGallery, { passive: true });
    track.addEventListener('scrollend', finishGalleryMove);
    track.addEventListener('pointerdown', interruptGallery, { passive: true });
    track.addEventListener('touchstart', interruptGallery, { passive: true });
    track.addEventListener('wheel', interruptGallery, { passive: true });
    window.addEventListener('resize', () => {
      const slide = realGallerySlide(galleryTarget) || galleryCurrent;
      resetGalleryTarget();
      if (slide) {
        galleryCurrent = slide;
        track.scrollTo({ left: galleryLeft(slide), behavior: 'instant' });
      }
    });
    function update() {
      const variant = variants.find(v => String(v.id) === select.value);
      const available = Boolean(variant && variant.available);
      root.querySelector('[name="add"]').disabled = !available;
      root.querySelector('[name="add"]').textContent = available ? 'Add to cart' : variant ? 'Sold out' : 'Unavailable';
      root.querySelector('[data-buy-now]').disabled = !available;
      if (variant) {
        root.querySelector('[data-product-price]').textContent = TFShopify.money(variant.price);
        const compare = root.querySelector('[data-product-compare]'); compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = compare.hidden ? '' : TFShopify.money(variant.compare_at_price);
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        if (options) options.querySelectorAll('[data-option-position]').forEach(field => {
          const index = Number(field.dataset.optionPosition) - 1;
          field.querySelectorAll('[data-option-value]').forEach(button => {
            const active = button.dataset.optionValue === variant.options[index]; button.classList.toggle('selected', active); button.setAttribute('aria-pressed', String(active));
          });
        });
        const frame = variant.options.map(v => String(v).toLowerCase().replace('natural wood', 'natural').replaceAll(' ', '-')).find(v => [...track.querySelectorAll('[data-frame]')].some(slide => slide.dataset.frame === v));
        track.querySelectorAll('[data-frame]').forEach(slide => slide.hidden = Boolean(frame && slide.dataset.frame !== frame));
        const mediaId = variant.featured_media && variant.featured_media.id;
        const frameMedia = frame && [...track.querySelectorAll('[data-frame]')].find(slide => slide.dataset.frame === frame);
        const variantMedia = mediaId && track.querySelector(`[data-media-id="${mediaId}"]`);
        const media = frameMedia || (variantMedia && !variantMedia.hidden ? variantMedia : null);
        rebuildGallery(media);
      }
    }
    if (options) {
      options.hidden = false;
      // Keep the native select as a working, accessible option selector and a no-JS fallback.
      options.addEventListener('click', event => {
        const button = event.target.closest('[data-option-value]'); if (!button) return;
        const current = variants.find(v => String(v.id) === select.value) || variants[0]; const chosen = [...current.options];
        const index = Number(button.closest('[data-option-position]').dataset.optionPosition) - 1; chosen[index] = button.dataset.optionValue;
        const match = variants.find(v => v.options.every((value, i) => value === chosen[i]));
        if (!match) {
          const error = root.querySelector('[data-product-error]'); error.textContent = 'This combination is unavailable. Choose another option.'; error.hidden = false; return;
        }
        root.querySelector('[data-product-error]').hidden = true; select.value = String(match.id); update();
      });
    }
    select.addEventListener('change', update);
    root.querySelector('[data-gallery-prev]').addEventListener('click', () => moveGallery(-1));
    root.querySelector('[data-gallery-next]').addEventListener('click', () => moveGallery(1));
    update();
  }
  function initHero() {
    const hero = document.getElementById('hero'); if (!hero || hero.dataset.bound) return; hero.dataset.bound = 'true';
    let current = 0; const slides = hero.querySelector('#heroSlides'); const total = slides.children.length; const dots = [...hero.querySelectorAll('.hero-dot')];
    const autoplay = TFCarouselAutoplay(() => go(current + 1), 9000);
    function go(value) { current = (value + total) % total; slides.style.transform = `translateX(-${current * 100 / total}%)`; dots.forEach((dot, i) => dot.classList.toggle('active', i === current)); [...slides.children].forEach((slide, i) => { slide.inert = i !== current; slide.setAttribute('aria-hidden', String(i !== current)); }); }
    hero.querySelector('#heroLeft').addEventListener('click', () => { go(current - 1); autoplay.reset(); });
    hero.querySelector('#heroRight').addEventListener('click', () => { go(current + 1); autoplay.reset(); });
    dots.forEach((dot, i) => { dot.role = 'button'; dot.tabIndex = 0; dot.setAttribute('aria-label', `Slide ${i + 1}`); dot.addEventListener('click', () => { go(i); autoplay.reset(); }); dot.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); dot.click(); } }); });
    let start; hero.addEventListener('touchstart', e => { start = e.touches[0].clientX; }, { passive: true }); hero.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - start; if (Math.abs(dx) > 40) { go(current + (dx < 0 ? 1 : -1)); autoplay.reset(); } }, { passive: true }); go(0);
  }
  function init() { initHero(); document.querySelectorAll('[data-tf-product]').forEach(initProduct); }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-return-toggle]');
    document.querySelectorAll('.tf-return-bubble').forEach(note => {
      const trigger = document.querySelector(`[aria-controls="${note.id}"]`);
      if (button === trigger) { note.hidden = !note.hidden; trigger.setAttribute('aria-expanded', String(!note.hidden)); }
      else if (!note.parentElement.contains(event.target)) { note.hidden = true; if (trigger) trigger.setAttribute('aria-expanded', 'false'); }
    });
    if (event.target.closest('[data-view-all]')) location.assign(JSON.parse(document.getElementById('tf-shop-config').textContent).root + 'collections/all');
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const note = document.querySelector('.tf-return-bubble:not([hidden])');
    if (note) { event.preventDefault(); event.stopPropagation(); note.hidden = true; const trigger = document.querySelector(`[aria-controls="${note.id}"]`); trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
  }, true);
  document.addEventListener('shopify:section:load', init);
  init();
})();
